import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Button, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { HubspotAPI } from "../../../lib/api/HubspotAPI";
import { Message } from "lib/models/Message";
import { orgNameSelector } from "../../../selectors/orgNameSelector";
import { validateEmail } from "../../Components/Form/validators";
const API = {
  hubspot: new HubspotAPI(),
};

const useStyles = makeStyles((theme) => ({
  outerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: `0 ${theme.shape.padding}px`,
  },
  largeText: {
    fontWeight: "bold",
  },
  button: {
    marginTop: theme.shape.padding,
  },
  textField: {
    minWidth: 450,
  },
  alert: {
    marginTop: theme.shape.padding,
  },
}));

const validateEmails = (emailList) => {
  for (const str of emailList) {
    if (validateEmail(str) === false) {
      return false;
    }
  }
  return true;
};

export const MSPSettingsPageView = (props) => {
  const classes = useStyles();
  const { orgName } = props;
  const [isSaving, setIsSaving] = useState(false);
  const [emailString, setEmailString] = useState("");
  const [alertToShow, setAlertToShow] = useState(false);

  useEffect(() => {
    if (!emailString && !isSaving) {
      // to handle async calls in useEffect hook
      // build func here and call immediately
      const fetchEmailString = async () => {
        // get existing contant email string here
        // and set it to state var for displaying
        const existingString = await getHubspotContactEmails();
        setEmailString(existingString);
      };
      fetchEmailString();
    }
  });

  const getHubspotContactEmails = async () => {
    try {
      // get the Company's data tied to this blumira org
      const { data: company } = await API.hubspot.getCompany();
      let emailStringToReturn = "";

      // if the company has existing contacat emails use 'em
      if (company.billing_contact_email) {
        emailStringToReturn = company.billing_contact_email;
      }

      return emailStringToReturn;
    } catch (e) {
      // Swallow error.
    }
  };

  const handleBlur = (e) => {
    if (validateEmails(e.target.value.split(", ")) === false) {
      toggleAlert("error");
    } else {
      toggleAlert();
    }
  };

  const handleChange = (e) => setEmailString(e.target.value);

  const handleSaveChanges = async () => {
    if (validateEmails(emailString.split(", ")) === false) {
      toggleAlert("error");
      return;
    }

    // disable button and update UI
    setIsSaving(true);

    const message = new Message({
      body: `MSP Organization ${orgName} billing report recipients are: ${emailString}`,
      recipient: "msp@blumira.com",
      subject: "MSP Organization Billing Report Recipients have changed",
      type: 30,
    });

    try {
      const messageResponse = await message.create();

      if (messageResponse.error === true) {
        toggleAlert("error");
        return;
      }
    } catch {
      toggleAlert("error");
      return;
    }

    try {
      // API expects emails as an array
      const emailArray = emailString.split(", ");

      const { statusCode } = await API.hubspot.updateBilling({
        billingContactEmails: emailArray,
      });

      // enablue button and update UI
      setIsSaving(false);

      // show alert based on response status
      if (statusCode === 200) {
        setEmailString("");
        toggleAlert("success");
      } else toggleAlert("error");
    } catch (e) {
      // Swallow error.
    }
  };

  const toggleAlert = (type) => {
    if (type) setAlertToShow(type);
    else setAlertToShow(false);
  };

  return (
    <div className={classes.outerContainer}>
      <h3 className={classes.largeText}>
        Email invoices and end-of-month billing report to:
      </h3>
      <TextField
        inputProps={{ "aria-label": "emailList" }}
        type="text"
        value={emailString}
        onChange={handleChange}
        className={classes.textField}
        helperText={"Separate multiple email addresses with a comma and space"}
        onBlur={handleBlur}
      />
      <Button
        color={"primary"}
        variant={"contained"}
        className={classes.button}
        onClick={handleSaveChanges}
        disabled={
          !emailString || isSaving || !validateEmails(emailString.split(", "))
        }
      >
        {isSaving ? "Saving..." : "Save changes"}
      </Button>
      {!!alertToShow && (
        <Alert
          severity={alertToShow}
          onClose={() => toggleAlert(false)}
          className={classes.alert}
        >
          {alertToShow === "success"
            ? "Successfully updated your billing contact emails."
            : "Oops, looks like something went wrong. Please double check your formatting and try again."}
        </Alert>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const orgName = orgNameSelector(state);

  return {
    orgName,
  };
};

export default connect(mapStateToProps, null)(MSPSettingsPageView);
